import React, { Fragment } from 'react'
import { Switch } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { InProgressComponent, SavingComponent } from './SavingComponent';
import { useContext } from 'react';
import { RoleContext } from './Context/RoleContext';
import { GlobalContext } from "../../Renderers/GlobalContext"
import useInternalUserCheck from '../../Hooks/Misc/useInternalUserCheck';
import { useTranslation } from 'react-i18next';
import { updateRole } from '../../API/Role/Role';

export const GeneralRights = (props) => {
    debugger
    const { state, dispatch } = useContext(RoleContext)
    const { subscription, user } = useContext(GlobalContext).state
    const isInternalUser = useInternalUserCheck(user.email)

    const { t, i18n } = useTranslation([
        "role/general_rights"
    ], {
        useSuspense: false
    });

    const Rights = [
        {
            text: t("dropdown_values.manage"),
            value: "Manage"
        },
        {
            text: t("dropdown_values.access"),
            value: "Access"
        },
        {
            text: t("dropdown_values.no_access"),
            value: "No access"
        }
    ]

    const handleChange = async (field, value) => {
        let role = { ...state.selectedRole }
        dispatch({ type: "ADD_TO_INPROGRESS", payload: field })
        await updateRole(role._id, { [field]: value })
        dispatch({ type: "UPDATE_ROLES", payload: { _id: role._id, properties: { [field]: value } } })
        dispatch({ type: "MOVE_TO_SAVE", payload: field })
    }

    const handleCheckboxChange = async (e) => {
        handleChange(e.target.name, e.value)
    }

    const handleDropdownChange = async (e) => {
        handleChange(e.target.name, e.target.value.value)
    }

    function getRightValueObjectFromString(string) {
        return Rights.find(x => x.value === string);
    }

    return (
        <div className="m-4 checkGenRole">
            <div className="row pt-2">
                <div className="col-12 mb-3">
                    <h2 className='font-size-3'>{t("rights_in_production.title")}</h2>
                    <p className="w-75 text-secondary">{t("rights_in_production.description")}</p>
                </div>
                <div className='col-12'>
                    <div className='row ps-4 pb-1'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.manage_user.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.manage_user.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <Switch
                                name="manageUsers"
                                disabled={
                                    subscription.rolesPermission === "Read only" ||
                                    (state.selectedRole.isDefaultRole && state.selectedRole.roleName === "Admin") ||
                                    (state.inProgressItems.includes("manageUsers"))
                                }
                                checked={state.selectedRole.manageUsers}
                                onChange={handleCheckboxChange}
                            />
                            {state.inProgressItems.includes("manageUsers") && <InProgressComponent />}
                            {state.savedItems.includes("manageUsers") && <SavingComponent />}
                        </div>
                    </div>
                    {subscription.showPlanning &&
                        <div className='row ps-4 pb-1'>
                            <div className='col-4'>
                                <strong>
                                    {t("rights_in_production.provide_feedback.title")}
                                </strong>
                                <p className='text-secondary'>
                                    {t("rights_in_production.provide_feedback.description")}
                                </p>
                            </div>
                            <div className='col-8'>
                                <Switch
                                    name="provideFeedback"
                                    disabled={(
                                        subscription.rolesPermission === "Read only" ||
                                        state.inProgressItems.includes("provideFeedback")
                                    )}
                                    checked={state.selectedRole.provideFeedback}
                                    onChange={handleCheckboxChange}
                                />
                                {state.inProgressItems.includes("provideFeedback") && <InProgressComponent />}
                                {state.savedItems.includes("provideFeedback") && <SavingComponent />}
                            </div>
                        </div>
                    }
                    <div className='row ps-4 pb-1'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.edit_app.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.edit_app.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <Switch
                                name="configureApp"
                                disabled={
                                    subscription.rolesPermission === "Read only" ||
                                    (state.selectedRole.isDefaultRole && state.selectedRole.roleName === "Admin") ||
                                    (state.inProgressItems.includes("configureApp"))
                                }
                                checked={state.selectedRole.configureApp}
                                onChange={handleCheckboxChange}
                            />
                            {state.inProgressItems.includes("configureApp") && <InProgressComponent />}
                            {state.savedItems.includes("configureApp") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4 pb-1'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.app_general_settings.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.app_general_settings.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <Switch
                                name="appGeneralSettings"
                                disabled={
                                    subscription.rolesPermission === "Read only" ||
                                    (state.selectedRole.isDefaultRole && state.selectedRole.roleName === "Admin") ||
                                    (state.inProgressItems.includes("appGeneralSettings"))
                                }
                                checked={state.selectedRole.appGeneralSettings}
                                onChange={handleCheckboxChange}
                            />
                            {state.inProgressItems.includes("appGeneralSettings") && <InProgressComponent />}
                            {state.savedItems.includes("appGeneralSettings") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4 pb-1'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.view_app_as_other_roles.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.view_app_as_other_roles.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <Switch
                                name="viewAppasOtherRolesinPublish"
                                disabled={(
                                    subscription.rolesPermission === "Read only" ||
                                    state.inProgressItems.includes("viewAppasOtherRolesinPublish")
                                )}
                                checked={state.selectedRole.viewAppasOtherRolesinPublish}
                                onChange={handleCheckboxChange}
                            />
                            {state.inProgressItems.includes("viewAppasOtherRolesinPublish") && <InProgressComponent />}
                            {state.savedItems.includes("viewAppasOtherRolesinPublish") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.import_rights.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.import_rights.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <Switch
                                name="importRights"
                                disabled={(
                                    subscription.rolesPermission === "Read only" ||
                                    state.inProgressItems.includes("importRights")
                                )}
                                checked={state.selectedRole.importRights}
                                onChange={handleCheckboxChange}
                            />
                            {state.inProgressItems.includes("importRights") && <InProgressComponent />}
                            {state.savedItems.includes("importRights") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.data_access_rights.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.data_access_rights.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <Switch
                                name="dataAccessRights"
                                disabled={
                                    subscription.rolesPermission === "Read only" ||
                                    (state.selectedRole.isDefaultRole && state.selectedRole.roleName === "Admin") ||
                                    (state.inProgressItems.includes("dataAccessRights"))
                                }
                                checked={state.selectedRole.dataAccessRights}
                                onChange={handleCheckboxChange}
                            />
                            {state.inProgressItems.includes("dataAccessRights") && <InProgressComponent />}
                            {state.savedItems.includes("dataAccessRights") && <SavingComponent />}
                        </div>
                    </div>
                    {subscription.showApiPerApp &&
                        <div className='row ps-4 pb-1'>
                            <div className='col-4'>
                                <strong>
                                    {t("rights_in_production.api_rights.title")}
                                </strong>
                                <p className='text-secondary'>
                                    {t("rights_in_production.api_rights.description")}
                                </p>
                            </div>
                            <div className='col-8'>
                                <Switch
                                    name="apiRights"
                                    disabled={(
                                        subscription.rolesPermission === "Read only" ||
                                        state.inProgressItems.includes("apiRights")
                                    )}
                                    checked={state.selectedRole.apiRights}
                                    onChange={handleCheckboxChange}
                                />
                                {state.inProgressItems.includes("apiRights") && <InProgressComponent />}
                                {state.savedItems.includes("apiRights") && <SavingComponent />}
                            </div>
                        </div>
                    }
                    <div className='row ps-4 pb-1'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.lookup_rights.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.lookup_rights.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <DropDownList
                                name="lookupRights"
                                disabled={(
                                    subscription.rolesPermission === "Read only" ||
                                    state.inProgressItems.includes("lookupRights")
                                )}
                                className="w-25"
                                data={Rights}
                                value={getRightValueObjectFromString(state.selectedRole.lookupRights)}
                                onChange={handleDropdownChange}
                                textField='text'
                            />
                            {state.inProgressItems.includes("lookupRights") && <InProgressComponent />}
                            {state.savedItems.includes("lookupRights") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.dashboard_rights.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.dashboard_rights.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <DropDownList
                                name="dashboardingRights"
                                disabled={(
                                    subscription.rolesPermission === "Read only" ||
                                    state.inProgressItems.includes("dashboardingRights")
                                )}
                                className="w-25"
                                data={Rights}
                                value={getRightValueObjectFromString(state.selectedRole.dashboardingRights)}
                                onChange={handleDropdownChange}
                                textField='text'
                            />
                            {state.inProgressItems.includes("dashboardingRights") && <InProgressComponent />}
                            {state.savedItems.includes("dashboardingRights") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.reporting_rights.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.reporting_rights.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <DropDownList
                                name="reportingRights"
                                disabled={(
                                    subscription.rolesPermission === "Read only" ||
                                    state.inProgressItems.includes("reportingRights")
                                )}
                                className="w-25"
                                data={Rights}
                                value={getRightValueObjectFromString(state.selectedRole.reportingRights)}
                                onChange={handleDropdownChange}
                                textField='text'
                            />
                            {state.inProgressItems.includes("reportingRights") && <InProgressComponent />}
                            {state.savedItems.includes("reportingRights") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.notification_rights.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.notification_rights.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <DropDownList
                                name="notificationRights"
                                disabled={(
                                    subscription.rolesPermission === "Read only" ||
                                    state.inProgressItems.includes("notificationRights")
                                )}
                                className="w-25"
                                data={Rights}
                                value={getRightValueObjectFromString(state.selectedRole.notificationRights)}
                                onChange={handleDropdownChange}
                                textField='text'
                            />
                            {state.inProgressItems.includes("notificationRights") && <InProgressComponent />}
                            {state.savedItems.includes("notificationRights") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4 pb-1'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.approval_rights.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.approval_rights.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <DropDownList
                                name="allowTaskWorkflowManagement"
                                disabled={(
                                    subscription.rolesPermission === "Read only" ||
                                    state.inProgressItems.includes("allowTaskWorkflowManagement")
                                )}
                                className="w-25"
                                data={Rights}
                                value={getRightValueObjectFromString(state.selectedRole.allowTaskWorkflowManagement)}
                                onChange={handleDropdownChange}
                                textField='text'
                            />
                            {state.inProgressItems.includes("allowTaskWorkflowManagement") && <InProgressComponent />}
                            {state.savedItems.includes("allowTaskWorkflowManagement") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4 pb-1'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.internal_workflow_rights.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.internal_workflow_rights.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <DropDownList
                                name="internalWorkflowRights"
                                disabled={(
                                    subscription.rolesPermission === "Read only" ||
                                    state.inProgressItems.includes("internalWorkflowRights")
                                )}
                                className="w-25"
                                data={Rights}
                                value={getRightValueObjectFromString(state.selectedRole.internalWorkflowRights)}
                                onChange={handleDropdownChange}
                                textField='text'
                            />
                            {state.inProgressItems.includes("internalWorkflowRights") && <InProgressComponent />}
                            {state.savedItems.includes("internalWorkflowRights") && <SavingComponent />}
                        </div>
                    </div>
                    <div className='row ps-4 pb-1'>
                        <div className='col-4'>
                            <strong>
                                {t("rights_in_production.shared_form_rights.title")}
                            </strong>
                            <p className='text-secondary'>
                                {t("rights_in_production.shared_form_rights.description")}
                            </p>
                        </div>
                        <div className='col-8'>
                            <DropDownList
                                name="sharedFormRights"
                                disabled={(
                                    subscription.rolesPermission === "Read only" ||
                                    state.inProgressItems.includes("sharedFormRights")
                                )}
                                className="w-25"
                                data={Rights}
                                value={getRightValueObjectFromString(state.selectedRole.sharedFormRights)}
                                onChange={handleDropdownChange}
                                textField='text'
                            />
                            {state.inProgressItems.includes("sharedFormRights") && <InProgressComponent />}
                            {state.savedItems.includes("sharedFormRights") && <SavingComponent />}
                        </div>
                    </div>
                </div>
            </div>
            {isInternalUser && state.advancedMode &&
                <Fragment>
                    <div className="overview-divider"></div>
                    <div className="row">
                        <div className="col-12">
                            <h2 className='font-size-3'>
                                {t("rights_in_preview.title")}
                            </h2>
                            <p className="w-75 text-secondary">
                                {t("rights_in_preview.description")}
                            </p>
                        </div>
                        <div className='col-12'>
                            <div className='row ps-4 pb-1'>
                                <div className='col-4'>
                                    <strong>
                                        {t("rights_in_preview.edit_app.title")}
                                    </strong>
                                    <p className='text-secondary'>
                                        {t("rights_in_preview.edit_app.description")}
                                    </p>
                                </div>
                                <div className='col-8'>
                                    <Switch
                                        name="configureAppinPreview"
                                        disabled={
                                            subscription.rolesPermission === "Read only" ||
                                            (state.selectedRole.isDefaultRole && state.selectedRole.roleName === "Admin") ||
                                            (state.inProgressItems.includes("configureAppinPreview"))
                                        }
                                        checked={state.selectedRole.configureAppinPreview}
                                        onChange={handleCheckboxChange}
                                    />
                                    {state.inProgressItems.includes("configureAppinPreview") && <InProgressComponent />}
                                    {state.savedItems.includes("configureAppinPreview") && <SavingComponent />}
                                </div>
                            </div>
                            <div className='row ps-4 pb-1'>
                                <div className='col-4'>
                                    <strong>
                                        {t("rights_in_preview.view_app_as_other_roles.title")}
                                    </strong>
                                    <p className='text-secondary'>
                                        {t("rights_in_preview.view_app_as_other_roles.description")}
                                    </p>
                                </div>
                                <div className='col-8'>
                                    <Switch
                                        name="viewAppasOtherRoles"
                                        disabled={
                                            subscription.rolesPermission === "Read only" ||
                                            (state.inProgressItems.includes("viewAppasOtherRoles"))
                                        }
                                        checked={state.selectedRole.viewAppasOtherRoles}
                                        onChange={handleCheckboxChange}
                                    />
                                    {state.inProgressItems.includes("viewAppasOtherRoles") && <InProgressComponent />}
                                    {state.savedItems.includes("viewAppasOtherRoles") && <SavingComponent />}
                                </div>
                            </div>
                            <div className='row ps-4'>
                                <div className='col-4'>
                                    <strong>
                                        {t("rights_in_preview.import_rights.title")}
                                    </strong>
                                    <p className='text-secondary'>
                                        {t("rights_in_preview.import_rights.description")}
                                    </p>
                                </div>
                                <div className='col-8'>
                                    <Switch
                                        name="importRightsinPreview"
                                        disabled={(
                                            subscription.rolesPermission === "Read only" ||
                                            state.inProgressItems.includes("importRightsinPreview")
                                        )}
                                        checked={state.selectedRole.importRightsinPreview}
                                        onChange={handleCheckboxChange}
                                    />
                                    {state.inProgressItems.includes("importRightsinPreview") && <InProgressComponent />}
                                    {state.savedItems.includes("importRightsinPreview") && <SavingComponent />}
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
        </div >
    )
}